import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Box, Button } from '@material-ui/core';
import StandardModal from '~/components/Modal';

import { Creators as ModalActions } from '~/store/modules/modal/ducks';
import { Creators as UsersActions } from '~/store/modules/users/ducks';

const MODAL_NAME = 'SEND_USER_TOKEN_CONFIRMATION';

export default function SendTokenModal() {
  const dispatch = useDispatch();
  const openModal = useSelector((state) => state.modal.active);
  const user = useSelector((state) => state.modal.params);

  const closeModal = () => {
    dispatch(ModalActions.closeModal());
  };

  const sendToken = () => {
    dispatch(UsersActions.sendUserToken(user.id));
    closeModal();
  };

  return (
    <StandardModal
      onClose={closeModal}
      isOpened={openModal === MODAL_NAME}
      maxWidth="xs"
      showDividers={false}
      slideTo="left"
      fullWidth
    >
      <Grid container alignItems="center">
        <Box mt={3}>
          <Grid item xs={12}>
            <Typography component="span" variant="body1">
              Você deseja realmente reenviar o token do usuário{' '}
              <strong>{user.name}</strong> ?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box mt={2} width={1} display="flex" justifyContent="flex-end">
              <Button
                variant="outlined"
                color="primary"
                onClick={() => sendToken()}
              >
                Enviar
              </Button>
            </Box>
          </Grid>
        </Box>
      </Grid>
    </StandardModal>
  );
}
